import React, { useState } from 'react';
import { WizardForm } from '../components/WizardForm';
import { QrCodeIcon, AlertTriangleIcon, CheckCircleIcon, CreditCardIcon, FileTextIcon } from 'lucide-react';
export function SmartPermitIssuance() {
  const [currentStep, setCurrentStep] = useState(0);
  const [formData, setFormData] = useState({
    smartId: '',
    harvesterName: '',
    resource: '',
    compartment: '',
    duration: '',
    paymentStatus: 'pending',
    // Three-Gate Check Status
    banPeriod: false,
    blacklist: false,
    blcExpiry: false,
    activeTrip: false,
    quotaReached: false
  });
  const wizardSteps = [{
    title: 'Scan Smart ID',
    description: 'Scan Harvester ID'
  }, {
    title: 'Permit Details',
    description: 'Resource & Compartment'
  }, {
    title: 'Three-Gate Check',
    calculate: true,
    description: 'System validation engine'
  }, {
    title: 'Payment & Issue',
    description: 'Confirm and generate'
  }];
  const runValidationEngine = () => {
    // Simulate validation logic
    setFormData(prev => ({
      ...prev,
      banPeriod: prev.resource === 'Honey' && new Date().getMonth() > 5,
      blacklist: Math.random() > 0.95,
      blcExpiry: Math.random() > 0.95,
      activeTrip: Math.random() > 0.9,
      quotaReached: Math.random() > 0.95
    }));
  };
  const isBlocked = formData.banPeriod || formData.blacklist || formData.blcExpiry || formData.activeTrip || formData.quotaReached;
  return <div className="space-y-6" data-id="element-2400">
      <div data-id="element-2401">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-2402">
          Smart Permit Issuance
        </h1>
        <p className="text-sm text-gray-600 mt-1" data-id="element-2403">
          Resource-specific permit generation with automated validation engine
        </p>
      </div>

      <WizardForm steps={wizardSteps} currentStep={currentStep} onStepChange={step => {
      if (step === 2 && currentStep === 1) {
        runValidationEngine();
      }
      setCurrentStep(step);
    }} onSubmit={() => {
      alert('Permit Generated Successfully with QR Code!');
      setCurrentStep(0);
      setFormData({
        smartId: '',
        harvesterName: '',
        resource: '',
        compartment: '',
        duration: '',
        paymentStatus: 'pending',
        banPeriod: false,
        blacklist: false,
        blcExpiry: false,
        activeTrip: false,
        quotaReached: false
      });
    }} data-id="element-2404">
        {currentStep === 0 && <div className="space-y-6" data-id="element-2405">
            <div className="bg-gray-50 border-2 border-dashed border-gray-300 rounded-xl p-8 text-center" data-id="element-2406">
              <QrCodeIcon size={48} className="mx-auto text-gray-400 mb-4" data-id="element-2407" />
              <h3 className="text-lg font-medium text-gray-900 mb-2" data-id="element-2408">
                Scan Harvester Smart ID
              </h3>
              <p className="text-sm text-gray-500 mb-6" data-id="element-2409">
                Use the RFID scanner or enter the ID manually
              </p>
              <div className="max-w-xs mx-auto flex gap-2" data-id="element-2410">
                <input type="text" value={formData.smartId} onChange={e => setFormData({
              ...formData,
              smartId: e.target.value
            })} placeholder="Enter Smart ID..." className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2411" />
                <button onClick={() => setFormData({
              ...formData,
              harvesterName: 'Rahim Uddin (Verified)'
            })} className="px-4 py-2 bg-[#1B5E20] text-white rounded-lg hover:bg-[#2E7D32]" data-id="element-2412">
                  Verify
                </button>
              </div>
            </div>
            {formData.harvesterName && <div className="bg-green-50 border border-green-200 rounded-lg p-4 flex items-center gap-3" data-id="element-2413">
                <CheckCircleIcon className="text-green-600" data-id="element-2414" />
                <span className="font-medium text-green-900" data-id="element-2415">
                  {formData.harvesterName}
                </span>
              </div>}
          </div>}

        {currentStep === 1 && <div className="space-y-4" data-id="element-2416">
            <div data-id="element-2417">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2418">
                Resource Type *
              </label>
              <select value={formData.resource} onChange={e => setFormData({
            ...formData,
            resource: e.target.value
          })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2419">
                <option value="" data-id="element-2420">Select Resource</option>
                <option value="Fish" data-id="element-2421">Fish</option>
                <option value="Honey" data-id="element-2422">Honey</option>
                <option value="Wood" data-id="element-2423">Wood</option>
                <option value="Golpata" data-id="element-2424">Golpata</option>
              </select>
            </div>
            <div className="grid grid-cols-2 gap-4" data-id="element-2425">
              <div data-id="element-2426">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2427">
                  Forest Compartment *
                </label>
                <select value={formData.compartment} onChange={e => setFormData({
              ...formData,
              compartment: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2428">
                  <option value="" data-id="element-2429">Select Compartment</option>
                  <option value="C-12" data-id="element-2430">Compartment 12</option>
                  <option value="C-14" data-id="element-2431">Compartment 14</option>
                  <option value="C-21" data-id="element-2432">Compartment 21</option>
                </select>
              </div>
              <div data-id="element-2433">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2434">
                  Duration (Days) *
                </label>
                <input type="number" value={formData.duration} onChange={e => setFormData({
              ...formData,
              duration: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1B5E20]" data-id="element-2435" />
              </div>
            </div>
          </div>}

        {currentStep === 2 && <div className="space-y-6" data-id="element-2436">
            <h3 className="font-bold text-gray-900 border-b pb-2" data-id="element-2437">
              Validation Engine Results
            </h3>

            <div className="grid gap-4" data-id="element-2438">
              {/* Three-Gate Check */}
              <div className={`p-4 rounded-lg border flex items-start gap-3 ${formData.banPeriod ? 'bg-red-50 border-red-200' : 'bg-green-50 border-green-200'}`} data-id="element-2439">
                {formData.banPeriod ? <AlertTriangleIcon className="text-red-600 mt-0.5" size={20} data-id="element-2440" /> : <CheckCircleIcon className="text-green-600 mt-0.5" size={20} data-id="element-2441" />}
                <div data-id="element-2442">
                  <div className={`font-semibold ${formData.banPeriod ? 'text-red-900' : 'text-green-900'}`} data-id="element-2443">
                    1. Ban Period Check
                  </div>
                  <div className={`text-sm ${formData.banPeriod ? 'text-red-700' : 'text-green-700'}`} data-id="element-2444">
                    {formData.banPeriod ? `Active ban period for ${formData.resource}. Issuance blocked.` : 'No active ban period.'}
                  </div>
                </div>
              </div>

              <div className={`p-4 rounded-lg border flex items-start gap-3 ${formData.blacklist ? 'bg-red-50 border-red-200' : 'bg-green-50 border-green-200'}`} data-id="element-2445">
                {formData.blacklist ? <AlertTriangleIcon className="text-red-600 mt-0.5" size={20} data-id="element-2446" /> : <CheckCircleIcon className="text-green-600 mt-0.5" size={20} data-id="element-2447" />}
                <div data-id="element-2448">
                  <div className={`font-semibold ${formData.blacklist ? 'text-red-900' : 'text-green-900'}`} data-id="element-2449">
                    2. Blacklist Check
                  </div>
                  <div className={`text-sm ${formData.blacklist ? 'text-red-700' : 'text-green-700'}`} data-id="element-2450">
                    {formData.blacklist ? 'Harvester is blacklisted.' : 'Harvester is clear.'}
                  </div>
                </div>
              </div>

              <div className={`p-4 rounded-lg border flex items-start gap-3 ${formData.blcExpiry ? 'bg-red-50 border-red-200' : 'bg-green-50 border-green-200'}`} data-id="element-2451">
                {formData.blcExpiry ? <AlertTriangleIcon className="text-red-600 mt-0.5" size={20} data-id="element-2452" /> : <CheckCircleIcon className="text-green-600 mt-0.5" size={20} data-id="element-2453" />}
                <div data-id="element-2454">
                  <div className={`font-semibold ${formData.blcExpiry ? 'text-red-900' : 'text-green-900'}`} data-id="element-2455">
                    3. BLC Expiry Check
                  </div>
                  <div className={`text-sm ${formData.blcExpiry ? 'text-red-700' : 'text-green-700'}`} data-id="element-2456">
                    {formData.blcExpiry ? 'Associated BLC is expired.' : 'BLC is valid.'}
                  </div>
                </div>
              </div>

              {/* Additional Policies */}
              <div className={`p-4 rounded-lg border flex items-start gap-3 ${formData.activeTrip ? 'bg-orange-50 border-orange-200' : 'bg-green-50 border-green-200'}`} data-id="element-2457">
                {formData.activeTrip ? <AlertTriangleIcon className="text-orange-600 mt-0.5" size={20} data-id="element-2458" /> : <CheckCircleIcon className="text-green-600 mt-0.5" size={20} data-id="element-2459" />}
                <div data-id="element-2460">
                  <div className={`font-semibold ${formData.activeTrip ? 'text-orange-900' : 'text-green-900'}`} data-id="element-2461">
                    One-Trip Policy
                  </div>
                  <div className={`text-sm ${formData.activeTrip ? 'text-orange-700' : 'text-green-700'}`} data-id="element-2462">
                    {formData.activeTrip ? 'Previous trip not marked returned. Cannot issue new permit.' : 'No active trips.'}
                  </div>
                </div>
              </div>

              <div className={`p-4 rounded-lg border flex items-start gap-3 ${formData.quotaReached ? 'bg-orange-50 border-orange-200' : 'bg-green-50 border-green-200'}`} data-id="element-2463">
                {formData.quotaReached ? <AlertTriangleIcon className="text-orange-600 mt-0.5" size={20} data-id="element-2464" /> : <CheckCircleIcon className="text-green-600 mt-0.5" size={20} data-id="element-2465" />}
                <div data-id="element-2466">
                  <div className={`font-semibold ${formData.quotaReached ? 'text-orange-900' : 'text-green-900'}`} data-id="element-2467">
                    Resource Quota
                  </div>
                  <div className={`text-sm ${formData.quotaReached ? 'text-orange-700' : 'text-green-700'}`} data-id="element-2468">
                    {formData.quotaReached ? 'Station limit reached for this resource.' : 'Quota available.'}
                  </div>
                </div>
              </div>
            </div>

            {isBlocked && <div className="bg-red-100 text-red-800 p-4 rounded-lg font-bold text-center" data-id="element-2469">
                ISSUANCE BLOCKED: Please resolve the flagged issues above.
              </div>}
          </div>}

        {currentStep === 3 && <div className="space-y-6" data-id="element-2470">
            {!isBlocked ? <>
                <div className="bg-blue-50 p-6 rounded-lg border border-blue-200 flex items-center justify-between" data-id="element-2471">
                  <div data-id="element-2472">
                    <h4 className="font-bold text-blue-900 flex items-center gap-2" data-id="element-2473">
                      <CreditCardIcon size={20} data-id="element-2474" /> Payment Confirmation
                    </h4>
                    <p className="text-sm text-blue-700 mt-1" data-id="element-2475">
                      Total Fee: ৳ 1,250
                    </p>
                  </div>
                  <button onClick={() => setFormData({
              ...formData,
              paymentStatus: 'paid'
            })} className={`px-6 py-2 rounded-lg font-medium transition-colors ${formData.paymentStatus === 'paid' ? 'bg-green-600 text-white' : 'bg-blue-600 text-white hover:bg-blue-700'}`} data-id="element-2476">
                    {formData.paymentStatus === 'paid' ? 'Paid ✓' : 'Confirm Payment'}
                  </button>
                </div>

                {formData.paymentStatus === 'paid' && <div className="bg-gray-50 border-2 border-dashed border-gray-300 rounded-xl p-8 text-center animate-in fade-in" data-id="element-2477">
                    <FileTextIcon size={48} className="mx-auto text-[#1B5E20] mb-4" data-id="element-2478" />
                    <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-2479">
                      Digital Permit Ready
                    </h3>
                    <p className="text-sm text-gray-500 mb-4" data-id="element-2480">
                      Permit will be generated with a secure QR code and digital
                      signature.
                    </p>
                    <div className="inline-block bg-white px-4 py-2 rounded-lg border border-gray-200 font-mono font-bold text-lg text-gray-900" data-id="element-2481">
                      PRM-2024-
                      {Math.floor(Math.random() * 10000).toString().padStart(4, '0')}
                    </div>
                  </div>}
              </> : <div className="text-center py-8 text-red-600 font-bold" data-id="element-2482">
                Cannot proceed. Validation checks failed.
              </div>}
          </div>}
      </WizardForm>
    </div>;
}